<template>
  <app-table :id="tableId" :options="options" @action="getListAction" />
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiURL";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      tableId: "analyze-report-table",
      rowData: {},
      options: {
        name: "analyze-report-table",
        url: `${actions.TECHNICAL_REVIEWER}/analyzeReport/index?status=606`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.$hub.$on("reload-table", () => {
      this.$hub.$emit("reload-" + this.tableId);
    });
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      window.location = `${actions.TECHNICAL_REVIEWER}/prepareFinalReportCommission/${this.rowData.id}/view`;
    },

    data() {},
  },
};
</script>
